// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "cva", "react", "../Typography", "../../common/utils", "../Icon", "../../icons"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("cva"), require("react"), require("../Typography"), require("../../common/utils"), require("../Icon"), require("../../icons"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.cva, global.react, global.Typography, global.utils, global.Icon, global.icons);
    global.Chip = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _cva, _react, _Typography, _utils, _Icon, icons) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChipVariant = _exports.Chip = void 0;
  _react = _interopRequireDefault(_react);
  icons = _interopRequireWildcard(icons);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  // Type guard function to validate IconType
  var isIconType = function isIconType(icon) {
    return typeof icon === 'string' && Object.keys(icons).includes(icon);
  };
  var ChipVariant = _exports.ChipVariant = /*#__PURE__*/function (ChipVariant) {
    ChipVariant["DEFAULT"] = "default";
    ChipVariant["OUTLINED"] = "outlined";
    return ChipVariant;
  }({});
  var chipStyles = (0, _cva.cva)({
    base: 'cop-py-0.5 cop-pl-3 cop-inline-flex cop-items-center cop-gap-1.5  cop-rounded-[4px] hover:cop-bg-[#f8f9fb] active:cop-bg-secondary focus:cop-outline-none focus:cop-outline-[1.5px] focus:cop-outline-primary focus:cop-outline-offset-[1px] cop-cursor-pointer',
    variants: {
      variant: {
        "default": '',
        outlined: 'cop-border cop-border-solid cop-border-secondary'
      },
      rightPadding: {
        "false": 'cop-pr-3',
        "true": 'cop-pr-2'
      },
      disabled: {
        "false": '',
        "true": 'cop-pointer-events-none cop-bg-[#F8F9FB] cop-text-gray-300'
      }
    },
    defaultVariants: {
      variant: ChipVariant.DEFAULT,
      rightPadding: false
    }
  });
  var RenderIcon = function RenderIcon(_ref) {
    var icon = _ref.icon;
    if (!icon) {
      return null;
    }
    if (typeof icon === 'string' && isIconType(icon)) {
      return /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        icon: icon,
        className: "cop-h-3 cop-w-3"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon);
  };
  var Chip = _exports.Chip = function Chip(_ref2) {
    var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? ChipVariant.DEFAULT : _ref2$variant,
      label = _ref2.label,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'sm' : _ref2$size,
      className = _ref2.className,
      prefixIcon = _ref2.prefixIcon,
      disabled = _ref2.disabled,
      onClick = _ref2.onClick,
      onClose = _ref2.onClose;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.cn)(chipStyles({
        variant: variant,
        rightPadding: Boolean(onClose),
        disabled: disabled
      }), className),
      "aria-disabled": disabled,
      role: "button",
      tabIndex: disabled ? -1 : 0 // Prevents focus when disabled
      ,
      onClick: !disabled ? onClick : undefined // Prevents click when disabled
    }, /*#__PURE__*/_react["default"].createElement(RenderIcon, {
      icon: prefixIcon
    }), /*#__PURE__*/_react["default"].createElement(_Typography.Body, {
      size: size === 'md' ? 'base' : 'sm'
    }, label), Boolean(onClose) ? /*#__PURE__*/_react["default"].createElement("span", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "Close",
      className: "cop-h-3 cop-w-3"
    })) : null);
  };
});
